export default __webpack_public_path__ + "static/0c0c5eaf90b8af3a842e661f9a6e3015.png";